'use client';

import { c as _c } from "react/compiler-runtime";
import { FOCUS_RING } from '@common/components/interaction';
import { cn } from '@core/utils';
import { Image } from '@/components/client';
interface CategoryGroupItemProps {
  imageUrl: string;
  groupName: string;
  active?: boolean;
  onClick: () => void;
}
export const CategoryGroupItem = t0 => {
  const $ = _c(16);
  const {
    imageUrl,
    groupName,
    active,
    onClick
  } = t0;
  const t1 = active && "bg-Gray-50";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex min-w-64 shrink-0 flex-col items-center gap-4 rounded-medium px-8 py-4 transition-opacity duration-200 ease-out", "mobile-tablet:w-64 mobile-tablet:gap-8 mobile-tablet:px-0 mobile-tablet:pb-8", FOCUS_RING, "hover:opacity-80 active:opacity-80", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== groupName || $[3] !== imageUrl) {
    t3 = imageUrl ? <Image src={imageUrl} alt={groupName} width={96} height={96} className="size-48 object-contain" loading="lazy" /> : <span className="size-48" />;
    $[2] = groupName;
    $[3] = imageUrl;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = active ? "font-700 text-Gray-900 mobile-tablet:font-400 mobile-tablet:text-Gray-600" : "font-600 text-Gray-600 mobile-tablet:font-400";
  let t5;
  if ($[5] !== t4) {
    t5 = cn("whitespace-nowrap typo-caption1", t4);
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== groupName || $[8] !== t5) {
    t6 = <span className={t5}>{groupName}</span>;
    $[7] = groupName;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== active || $[11] !== onClick || $[12] !== t2 || $[13] !== t3 || $[14] !== t6) {
    t7 = <button aria-pressed={active} className={t2} onClick={onClick}>{t3}{t6}</button>;
    $[10] = active;
    $[11] = onClick;
    $[12] = t2;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};